import sliderApi from "../api/slider-api";

/**
 * NMU-473: homepage slider cards.
 *
 * These endpoints answer with a bare SliderBean / SliderBean[], not the SUCCESS
 * envelope — same shape as the programs API. `status` on the bean is the
 * published flag (a boolean), so it is only read as an envelope verdict when it
 * is actually a string; reading a boolean as one is what broke the programmes
 * page in NMU-453 and the preview button in NMU-451.
 */
const assertSuccess = (resp) => {
    if (resp && typeof resp.status === "string" && resp.status !== "SUCCESS") {
        throw resp.responseMsgTh || resp.responseMsgEn || resp.message || resp.status;
    }
    return resp;
};

const normalizeList = (resp) => {
    if (!resp) return [];
    if (Array.isArray(resp)) return resp;
    const raw = resp.data || resp.list;
    return Array.isArray(raw) ? raw : [];
};

const normalizeBean = (resp) => {
    if (!resp) return null;
    if (resp.bean) return resp.bean;
    if (resp.data && !Array.isArray(resp.data)) return resp.data;
    return resp;
};

const search = async (condition) => normalizeList(await sliderApi.search(condition));

const getById = async (id) => {
    const resp = await sliderApi.getById(id);
    assertSuccess(resp);
    return normalizeBean(resp);
};

const add = async (bean) => assertSuccess(await sliderApi.add(bean));
const edit = async (id, bean) => assertSuccess(await sliderApi.edit(id, bean));
const remove = async (id) => assertSuccess(await sliderApi.remove(id));
const reorder = async (orderedIds) => assertSuccess(await sliderApi.reorder(orderedIds));

const sliderService = { search, getById, add, edit, remove, reorder, normalizeList, normalizeBean };

export default sliderService;
